<div class="table-container" *ngIf="dataIsReady && input?.meals">
  <div *ngFor="let meal of input.meals; let i = index; let first = first">
    <div
      [ngStyle]="{ 'margin-top': first ? '0' : '16px' }"
      class="table-cell"
      (click)="goToDetail(i)"
    >
      <img
        class="table-cell-icon"
        src="assets/plan/{{
          meal.meal.startsWith('snack') ? 'snack' : meal.meal
        }}.png"
      />
      <div class="table-cell-title">{{ mealTitle[i] }}</div>
      <div class="table-cell-description">{{ sugestedCalorie[i] }}</div>
      <img class="table-cell-more-icon" src="assets/general/left-gray.svg" />
    </div>
  </div>
</div>
<div class="table-container" *ngIf="!dataIsReady">
  <div *ngFor="let meal of mealTitle; let i = index; let first = first">
    <div [ngStyle]="{ 'margin-top': first ? '0' : '16px' }" class="table-cell">
      <ngx-skeleton-loader
        appearance="circle"
        [theme]="{
          top: '16px',
          right: '16px',
          height: '32px',
          width: '32px',
          position: 'absolute',
          'background-color': '#e8eaef',
          margin: '0'
        }"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        [theme]="{
          top: '8px',
          right: '64px',
          height: '22px',
          width: '100px',
          position: 'absolute',
          'background-color': '#f8f9fa'
        }"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        [theme]="{
          top: '34px',
          right: '64px',
          height: '22px',
          width: '150px',
          position: 'absolute',
          'background-color': '#f3f4f6'
        }"
      ></ngx-skeleton-loader>
      <img class="table-cell-more-icon" src="assets/general/left-gray.svg" />
    </div>
  </div>
</div>
